import type * as ModelType from "@/components/features/faq/model/type";
import type { SearchedContent } from "@/components/features/faq/ui/hooks/search-contents/type";

import * as Composition from "./composition";

export const contentsToSearchedContentsConverter = (contents: Array<ModelType.Content>): SearchedContent => {
	// unique な category を取得
	const filteredUniqueCategories = Composition.Filter.uniqueCategoriesFilter(contents);
	// unique な subcategory を取得
	const filteredUniqueSubcategories = Composition.Filter.uniqueSubCategoriesFilter(contents);
	return filteredUniqueCategories.map((categoryName) => ({
		categoryKey: categoryName,
		categoryText: categoryName,
		categoryName: categoryName,
		subcategories: filteredUniqueSubcategories
			.filter((content) => content.categoryName === categoryName)
			.map((subcategory) => ({
				key: `${categoryName}-${subcategory.name}`,
				text: subcategory.name,
				name: subcategory.name,
				contents: contents
					.filter(
						(content) =>
							content.categoryName === categoryName && content.subcategoryName === subcategory.name,
					)
					.map((content) => ({
						id: content.id,
						text: content.text,
						publicUrl: content.publicUrl,
					})),
			})),
	}));
};
